import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Late-night fun",
  "description": "",
  "published": "2008-10-29T00:00:00.000Z",
  "redirect_from": ["/blog/latenight-fun/swizec/49"],
  "categories": "funny, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This is probably the most fun `}<a parentName="p" {...{
        "href": "http://slashdot.org/comments.pl?sid=1012203&cid=25564795"
      }}>{`conversation`}</a>{` I've ever had at four in the morning, certainly the most entertaining I've ever had on `}<a parentName="p" {...{
        "href": "http://slashdot.org"
      }}>{`slashdot`}</a>{`.`}</p>
    <p><strong parentName="p">{`phantomfive:`}</strong></p>
    <p>{`Seriously. I like the idea of doing research for the sake of research, and I would probably respect this more, except Microsoft keeps representing it as`}<br parentName="p"></br>{`
`}{`The coolest thing they have ever come up with.`}<br parentName="p"></br>{`
`}{`The future of computing.`}</p>
    <p>{`and it is neither, it is just cool research. It's so cute the way Microsoft has gotten all senile and out of touch in its old age.`}</p>
    <p>{`OK, off to do laundry now. When will they make a robot that does my laundry for me? Now THAT will be progress.`}</p>
    <p><strong parentName="p">{`swizec:`}</strong></p>
    <p>{`It's called a washing machine.`}</p>
    <p><strong parentName="p">{`snowraver1:`}</strong></p>
    <p>{`He's talking about a folding machine, and it would truly be a great invention. Just dump in the laundry and out comes a folded pile. Bonus if it sorts socks!`}</p>
    <p><strong parentName="p">{`swizec:`}</strong></p>
    <p>{`It's called a wife.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      